// One badge vocabulary shared by the review queue, the device-page manual list,
// the crawl run strip, and the Web search usage log (ADR 0076) so those surfaces
// speak the same status language. The colour comes from `.admin-badge-<status>`
// in admin.css (suggested/published/rejected for manuals; running/succeeded/
// failed for runs). Each status also takes the matching .tb-chip variant from
// ui.css: good, warn, bad or accent, and the plain grey chip otherwise.
//
// `status` selects the colour class; `label` is the visible text (defaults to
// `status`). The split lets a caller reuse a colour for a different vocabulary —
// e.g. the search log maps ok→succeeded (green) / error→failed (red) while
// showing the literal "ok"/"error" — without cloning this component.

const CHIP_TONE: Record<string, string> = {
  published: 'good',
  succeeded: 'good',
  suggested: 'warn',
  running: 'warn',
  rejected: 'bad',
  failed: 'bad',
  ai: 'accent',
};

export function StatusBadge({
  status,
  label,
}: {
  status: string;
  label?: string;
}): React.ReactElement {
  const tone = CHIP_TONE[status];
  const chip = tone === undefined ? 'tb-chip' : `tb-chip tb-chip--${tone}`;
  return <span className={`${chip} admin-badge admin-badge-${status}`}>{label ?? status}</span>;
}
